import Navbar from '../components/landing/Navbar'
import AgentWorkflow from '../components/agent/AgentWorkflow'
import { Sparkles } from 'lucide-react'

export default function AgentPage() {
    return (
        <div className="min-h-screen bg-slate-950 bg-[radial-gradient(ellipse_at_top,_var(--tw-gradient-stops))] from-slate-900 via-slate-950 to-slate-950">
            <Navbar />

            <main className="container mx-auto px-4 py-12 sm:py-24">
                <div className="mb-12 text-center">
                    <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 text-sm font-medium mb-6 animate-fade-in">
                        <Sparkles className="w-3 h-3" />
                        <span>InkSpot Agent v1.0</span>
                    </div>
                </div>

                <AgentWorkflow />
            </main>
        </div>
    )
}
